type CookieOptions = {
  days?: number
  path?: string
  sameSite?: 'Strict' | 'Lax' | 'None'
  secure?: boolean
}

export function setCookie(name: string, value: string, days = 180, opts: Omit<CookieOptions, 'days'> = {}): void {
  if (typeof document === 'undefined') return
  const path = opts.path ?? '/'
  const sameSite = opts.sameSite ?? 'Lax'
  const secure = opts.secure ?? (typeof window !== 'undefined' && window.location.protocol === 'https:')
  const maxAge = days > 0 ? `; Max-Age=${days * 24 * 60 * 60}` : ''
  const secureFlag = secure ? '; Secure' : ''
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=${path}${maxAge}; SameSite=${sameSite}${secureFlag}`
}

export function getCookie(name: string): string | undefined {
  if (typeof document === 'undefined') return undefined
  const prefix = `${name}=`
  for (const part of document.cookie.split('; ')) {
    if (part.startsWith(prefix)) {
      return decodeURIComponent(part.slice(prefix.length))
    }
  }
  return undefined
}

export function deleteCookie(name: string, path = '/'): void {
  if (typeof document === 'undefined') return
  document.cookie = `${name}=; Path=${path}; Max-Age=0; SameSite=Lax`
}
